import { render } from "./PricingContent.vue?vue&type=template&id=4146603f"
import script from "./PricingContent.vue?vue&type=script&lang=js"
export * from "./PricingContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__